import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardHeader } from 'reactstrap';

import { GroupCount } from '../../hooks/use-entity-overview';

export const ChartGroupBar = ({
  groupsCount,
}: {
  groupsCount: GroupCount[];
}) => {
  const series = [
    {
      data: [groupsCount[0]?.counter, groupsCount[1]?.counter],
    },
  ];

  const options = {
    chart: {
      toolbar: {
        show: false,
      },
      stacked: false,
    },
    colors: ['#46CB85', '#ADB5BD'],
    plotOptions: {
      bar: {
        horizontal: false,
        barHeight: '70%',
        columnWidth: '60%',
        distributed: true,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ['#ffffff'],
      },
    },
    grid: {
      borderColor: '#f1f1f1',
    },
    xaxis: {
      categories: ['Ativos', 'Arquivados'],
      title: {
        text: 'Total de Grupos',
        horizontalAlign: 'center',
        style: {
          color: '#7D8592',
          fontWeight: 500,
          fontSize: '15px',
          backgroundColor: '#f8f9fa',
        },
      },
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      labels: {
        colors: ['#46CB85', '#ADB5BD'],
        useSeriesColors: true,
      },
    },
    tooltip: {
      y: {
        formatter: function (value: number, { dataPointIndex }: any) {
          const labels = ['Ativos', 'Arquivados'];
          return `${labels[dataPointIndex]}: ${value}`;
        },
        title: {
          formatter: () => '',
        },
      },
    },
  };
  return (
    <React.Fragment>
      <Card className="pb-3 card-height-100 d-flex flex-column">
        <CardHeader className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Grupos</h4>
        </CardHeader>
        <ReactApexChart
          dir="ltr"
          type="bar"
          height={500}
          series={series}
          options={options}
          className="apex-charts"
        />
      </Card>
    </React.Fragment>
  );
};
